import { supabase } from '@/lib/supabase';

export const updateProjectContact = async ({
  projectId,
  contact,
  field = 'main_contact',
}: {
  projectId: number;
  contact: string;
  field?: 'main_contact' | 'contractor_contact' | 'client_contact';
}) => {
  const { error } = await supabase
    .from('projects')
    .update({ [field]: contact })
    .eq('id', projectId);
  if (error) throw error;
};
